@mixin background-font-color($backgroundColor, $fontColor) {
  background-color: $backgroundColor;
  color: $fontColor;
}

@mixin custom-tab-color($backgroundColor, $fontColor) {
  &.ux-button {
    color: $fontColor;

    &--toggle-active {
      @include background-font-color($backgroundColor, $fontColor);
    }

    &:not(active, .ux-button--disabled):hover {
      @include background-font-color($backgroundColor, $fontColor);
    }
  }
}

.ux-tab-switcher {
  &.ux-button--icon-only ux-icon {
    margin-top: 50%;
    transform: translateY(-50%);
  }

  &--no-border.ux-button--toggle,
  &--no-border.ux-button:not(.ux-button--disabled) {
    border: 0;
  }

  &--grey {
    @include custom-tab-color($color-blue-background-light, $color-black);
  }

  &--link {
    ux-icon {
      transform: translateY(-15%);
    }
  }
}
